import { render } from "./NewsFeed.vue?vue&type=template&id=40dc0a5c&scoped=true&ts=true"
import script from "./NewsFeed.vue?vue&type=script&lang=ts"
export * from "./NewsFeed.vue?vue&type=script&lang=ts"

import "./NewsFeed.vue?vue&type=style&index=0&id=40dc0a5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dc0a5c"]])

export default __exports__